// This file is intended to house logic related to generic Lyceum emotion CSS
// styles (https://emotion.sh/docs/object-styles). Generic meaning they could
// conceivably be heavily re-used by code in many domains, and there's no one
// specific area of our product they serve.
import { CSSObject } from "@emotion/react";

export const plainListCss = {
  margin: 0,
  padding: 0,
  "> li": {
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
};

export const plainListCssShare = {
  margin: 0,
  padding: 0,
  "> li": {
    listStyle: "none",
    margin: 20,
    padding: 0,
  },
};

export const flexboxAlignItemsCenterCss = {
  display: "flex",
  alignItems: "center",
};

/**
 * Visually hidden elements detectable by screen readers.
 *
 * Reference: https://webaim.org/techniques/css/invisiblecontent/
 */
export const screenReaderOnlyCss: CSSObject = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap" /* prevents text wrapping */,
  borderWidth: 0 /* ensures borders don't add space */,
  clipPath: "inset(50%)" /* modern version of clip */,
};

export const unstyledHeadingsCss: CSSObject = {
  fontSize: "inherit", // Resets size (h2 is usually 1.5em)
  fontWeight: "inherit", // Resets boldness (h2 is usually bold)
  lineHeight: "inherit", // Resets line spacing
  margin: 0, // Removes top/bottom whitespace
  padding: 0, // Just to be safe
  color: "inherit", // Ensures it uses the text color defined by parents
  // We may need to set `display` as a function argument if we need a
  // different configuration in different contexts.
  display: "inline",
};
